export default {
  pageTitle: {
    fontSize: '1.125em',
    fontWeight: '600',
    margin: '0 0 10px 0',
    lineHeight: 'inherit',
  },
} as const;
